import { BUILT_IN_ROLE_IDS, type RoleView } from "@starsach/shared-types";
import { StatusPill } from "../../components/ui";

/** Built-ins first, then the organisation's own by name - the same order everywhere a role list is shown. */
export function orderRoles<T extends { roleId: string; name: string }>(roles: T[]): T[] {
  const rank = (r: T) => (BUILT_IN_ROLE_IDS as readonly string[]).indexOf(r.roleId);
  return [...roles].sort((a, b) => {
    const ra = rank(a);
    const rb = rank(b);
    if (ra >= 0 || rb >= 0) return (ra < 0 ? 99 : ra) - (rb < 0 ? 99 : rb);
    return a.name.localeCompare(b.name);
  });
}

/** Role ids as pills, built-ins first; an id the organisation no longer has is shown bare so nothing is hidden. */
export function RolePills({ roleIds, roles, muted = false }: { roleIds: readonly string[]; roles: RoleView[] | undefined; muted?: boolean }) {
  const known = roleIds.map((id) => roles?.find((r) => r.roleId === id) ?? { roleId: id, name: id, builtIn: false });
  if (known.length === 0) return <span className="text-sm text-neutral-500">none</span>;
  return (
    <span className="flex flex-wrap gap-1">
      {orderRoles(known).map((r) => (
        <StatusPill key={r.roleId} status={r.name} tone={muted ? "neutral" : r.roleId === "manager" ? "ok" : "neutral"} />
      ))}
    </span>
  );
}
